export const MESSAGES = {
  MC: 'dex.message.MC',
  MC0: 'dex.message.MC0',
  MC1: 'dex.message.MC1',
  MC2: 'dex.message.MC2',
  MC3: 'dex.message.MC3',
  MC4: 'dex.message.MC4',
  MC5: 'dex.message.MC5',
  MC6: 'dex.message.MC6',
  MC7: 'dex.message.MC7',
  MC8: 'dex.message.MC8',
  MC9: 'dex.message.MC9',
  MC10: 'dex.message.MC10',
  MC11: 'dex.message.MC11',
  MC12: 'dex.message.MC12',
  MC13: 'dex.message.MC13',
  MC14: 'dex.message.MC14',
  MC15: 'dex.message.MC15',
  MC16: 'dex.message.MC16',
  MC17: 'dex.message.MC17',
  MC18: 'dex.message.MC18',
  MC19: 'dex.message.MC19',
  MC20: 'dex.message.MC20',
  MC21: 'dex.message.MC21',
  MC22: 'dex.message.MC22',
  MC23: 'dex.message.MC23',
  MC24: 'dex.message.MC24',
  MC25: 'dex.message.MC25',
  MC26: 'dex.message.MC26',
  MC27: 'dex.message.MC27',
  MC28: 'dex.message.MC28',
  MC29: 'dex.message.MC29',
  MC30: 'dex.message.MC30',
  MC31: 'dex.message.MC31',
  MC32: 'dex.message.MC32',
  MC33: 'dex.message.MC33',
  MC34: 'dex.message.MC34',
  MC35: 'dex.message.MC35',
  MC36: 'dex.message.MC36',
  MC37: 'dex.message.MC37',
  MC38: 'dex.message.MC38',
  MC39: 'dex.message.MC39',
  MC40: 'dex.message.MC40',
  MC41: 'dex.message.MC41',
  MC42: 'dex.message.MC42',
  MC43: 'dex.message.MC43',
  MC44: 'dex.message.MC44',
  MC45: 'dex.message.MC45',
  MC46: 'dex.message.MC46',
  MC47: 'dex.message.MC47',
  MC48: 'dex.message.MC48',
  MC49: 'dex.message.MC49',
  MC50: 'dex.message.MC50',
  MC51: 'dex.message.MC51',
  MC52: 'dex.message.MC52',
  MC53: 'dex.message.MC53',
  MC54: 'dex.message.MC54',
  MC55: 'dex.message.MC55',
  MC56: 'dex.message.MC56',
  MC57: 'dex.message.MC57',
};

export const ERRORS = {
  USER_NOT_CHOOSE_ACCOUNT: 'dex.error.userNotChooseAccount',
  USER_NOT_SIGN_MESSAGE: 'dex.error.userNotSignMessage',
  UN_SUPPORT_CHAIN: 'dex.error.unSupportChain',
  USER_DENIED_MESSAGE_SIGNATURE: 'dex.error.userDeniedMessageSignature',
  USER_REJECT_THE_TRANSACTION: 'dex.error.userRejectTheTransaction',
  SESSION_EXPIRED: 'dex.error.sessionExpired',
};
